
























































import { Component, Vue } from 'vue-property-decorator';
import MultiChunkUploader from '@/components/ChunkUploader/MultiChunkUploader.vue';
import DocumentAttachmentCreation from './DocumentAttachmentCreation.vue'
import { General } from '@/services/General';
import axios from 'axios';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { i18n } from '@/i18n/i18n-setup';
import { ClaimEnum } from '@/services/ClaimEnum';

@Component({
    components: {
        MultiChunkUploader,
        DocumentAttachmentCreation,
    }
})
export default class DocumentAttachment extends Vue {

    resultsItems = null;
    showLoading = false;
    isAdmin = false;

    async mounted() {
        this.isAdmin = General.CheckAuthorization(ClaimEnum.CanAdminNet20)
        this.resultsItems = await this.getDocumentsAsync();
    }

    async refreshResuts(){
        this.resultsItems = await this.getDocumentsAsync();
    }

    async getDocumentsAsync(): Promise<Array<any>> {
        this.showLoading = true;
        this.resultsItems = null;
        try {
            let response = await axios.get<any>(
                General.GetApiUrl('/api/net20/GetDocumentAttachmentsForUser'), {
                responseType: 'json',
                withCredentials: true
            });
            if (response.data) {
                this.showLoading = false;
                return response.data;
            }
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    deleteDocumentAsync(fileId: string) {
        let message = i18n.t('NET20.CUSTOMER_DOC_DELETE_QUESTION') as string;
        General.confirm(
            message,
            this,
            async () => {
                await this.deleteDocumentAsyncDo(fileId);
            }
        );
    }

    async downloadDocumentAsync(fileId: string, fileName: string): Promise<Array<any>> {
        try {
            let response = await axios.get<any>(
                General.GetApiUrl('/api/net20/DownloadDocumentAttachment?documentId=' + fileId), {
                responseType: 'blob',
                withCredentials: true,
            }
            );
            saveAs(new Blob([response.data]), fileName);
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    async deleteDocumentAsyncDo(fileId: string) {
        try {
            let response = await axios.delete<any>(
                General.GetApiUrl('/api/net20/DeleteDocumentAttachment?documentId=' + fileId), {
                responseType: 'json',
                withCredentials: true,
            }
            );
            this.resultsItems = await this.getDocumentsAsync();
            let message = i18n.t('NET20.CUSTOMER_DOC_DELETE_SUCCESS') as string;
            General.showAlertSuccess(message, this);
        } catch (ex) {

            General.HandleError(ex, this);
            return null;

        }

    }

    formatDate(value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }

    openCreationDocsModal() {
        this.$bvModal.show('document-attachments-creation-modal');
    }
}
